export default __webpack_public_path__ + "static/media/star.4e6c38bb.svg";